export const downloadAnything = (filename: string, payload: any, mime = 'text/plain') => {
  const blob = new Blob([payload], { type: mime })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
}

export const downloadJson = (filename: string, payload: any) =>
  downloadAnything(filename, JSON.stringify(payload, null, 2), 'application/json')
export const downloadCsv = (filename: string, payload: string) => downloadAnything(filename, payload, 'text/csv')
